import { render, staticRenderFns } from "./RiskModeShell.vue?vue&type=template&id=458977ab&scoped=true"
import script from "./RiskModeShell.vue?vue&type=script&lang=js"
export * from "./RiskModeShell.vue?vue&type=script&lang=js"
import style0 from "./RiskModeShell.vue?vue&type=style&index=0&id=458977ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458977ab",
  null
  
)

export default component.exports